export const SALESFORCE_URL_PREFIX =
  'https://transfix.lightning.force.com/lightning/r/Pricing_Request__c/'
